import React from 'react';
import Link from '@material-ui/core/Link';
import ArrowBackIcon from '@material-ui/icons/ArrowBack';
import { makeStyles } from '@material-ui/styles';
import { Grid } from '@material-ui/core';
import { useSelector } from 'react-redux';

import { getLocalizedContent as l } from '@helpers/languages';
import contentJson from './BackLink.json';

const useStyles = makeStyles(() => ({
  text: {
    marginLeft: '12px',
    fontStretch: 'condensed',
  },
  icon: {
    fontSize: '20px',
  },
}));

export const BackLink = ({ ...props }) => {
  const classes = useStyles();
  const {
    appState: { prefixLanguage },
  } = useSelector(state => state);

  return (
    <Link underline="none" {...props}>
      <Grid container alignItems="stretch">
        <Grid item>
          <ArrowBackIcon className={classes.icon} />
        </Grid>
        <Grid item className={classes.text}>
          {l(contentJson.backText, prefixLanguage)}
        </Grid>
      </Grid>
    </Link>
  );
};
